import joi, { ObjectSchema } from 'joi';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { JoiValidationOptionsConstant } from '@vivli/shared/infrastructure/constants';
import { IPublishingData, IPublishingRules, IPublishing } from '@vivli/features/data-requests/infrastructure/interface';

const publishingRulesSchema: ObjectSchema<IPublishingRules> = joi
    .object({
        publishedStatus: joi.string(),
        showWithdrawn: joi.boolean(),
        showLeadInvestigator: joi.boolean(),
        showTitleOfProposedResearch: joi.boolean(),
        showVivliDataRequestIdInfo: joi.boolean(),
        showFundingSource: joi.boolean(),
        showPotentialConflictsOfInterest: joi.boolean(),
        showStatisticalAnalysisPlan: joi.boolean(),
        showAdditionalInformation: joi.boolean(),
        showPublicDisclosures: joi.boolean(),
        showSummaryOfResults: joi.boolean(),
        showLaySummary: joi.boolean(),
    })
    .options(JoiValidationOptionsConstant);

const publishingDataFormSchema: ObjectSchema<IPublishingData> = joi
    .object({
        additionalInformation: joi.string(),
        withdrawnDate: joi.string(),
        vivliDataRequestIdInfo: joi.string(),
        summaryOfResults: joi.string(),
    })
    .options(JoiValidationOptionsConstant);



export const publishingFormSchema: ObjectSchema<IPublishing> = joi.object({
    publishingRules: publishingRulesSchema,
    publishingData: publishingDataFormSchema,
});

export function useApprovedPublishingForm(publishing: IPublishing, mode: 'onBlur' | 'onChange' | 'onTouched' | 'all' = 'all') {
    return useForm({
        mode,
        resolver: joiResolver(publishingFormSchema.options(JoiValidationOptionsConstant)),
        defaultValues: publishing,
        reValidateMode: 'onChange',
    });
}
